/* Purchase orders, receiving (goods receipts) and supplier returns.
 * Shared vocabulary (Save, Cancel, Status, Supplier, statuses…) lives in
 * common.js / shell.js and is intentionally not repeated here. */
const dict = {
  // --- Purchase orders: list -----------------------------------------------
  'Commit to suppliers, route for approval and issue orders. Convert approved requisitions into POs.':
    'Buat komitmen kepada pemasok, alurkan persetujuan, dan terbitkan pesanan. Ubah permintaan barang yang disetujui menjadi PO.',
  'New order': 'Pesanan baru',
  'Search by number, title or supplier…': 'Cari berdasarkan nomor, judul, atau pemasok…',
  'Failed to load purchase orders.': 'Gagal memuat pesanan pembelian.',
  "Couldn't load purchase orders": 'Tidak dapat memuat pesanan pembelian',
  'No matching purchase orders': 'Tidak ada pesanan pembelian yang cocok',
  'No purchase orders yet': 'Belum ada pesanan pembelian',
  'Try adjusting your search or filters.': 'Coba ubah pencarian atau filter Anda.',
  'Raise an order directly, or convert an approved requisition into a purchase order.':
    'Buat pesanan secara langsung, atau ubah permintaan barang yang disetujui menjadi pesanan pembelian.',
  'Title': 'Judul',
  'Lines': 'Baris',
  'Expected': 'Perkiraan tiba',
  'Source': 'Sumber',
  'From requisition': 'Dari permintaan barang',
  'Raised directly': 'Dibuat langsung',
  'No supplier assigned': 'Belum ada pemasok',

  // --- Purchase orders: detail ---------------------------------------------
  'Purchase order not found.': 'Pesanan pembelian tidak ditemukan.',
  "Couldn't load purchase order": 'Tidak dapat memuat pesanan pembelian',
  'Not found.': 'Tidak ditemukan.',
  'Back to purchase orders': 'Kembali ke pesanan pembelian',
  'Action failed': 'Tindakan gagal',
  'Could not post comment': 'Tidak dapat mengirim komentar',
  'Submitted for approval': 'Diajukan untuk persetujuan',
  'Purchase order cancelled': 'Pesanan pembelian dibatalkan',
  'Order short-closed': 'Pesanan ditutup lebih awal',
  'Enter a recipient email address.': 'Masukkan alamat email penerima.',
  'Order emailed to {recipient}': 'Pesanan dikirim melalui email ke {recipient}',
  'A reason is required to reject.': 'Alasan wajib diisi untuk menolak.',
  'Purchase order approved': 'Pesanan pembelian disetujui',
  'Purchase order rejected': 'Pesanan pembelian ditolak',
  'Purchase order deleted': 'Pesanan pembelian dihapus',
  'Could not delete': 'Tidak dapat menghapus',
  'Not assigned': 'Belum ditetapkan',
  'Deliver to': 'Kirim ke',
  'Source requisition': 'Permintaan barang sumber',
  'Raised by': 'Dibuat oleh',
  'Submitted': 'Diajukan',
  'GL account': 'Akun GL',
  'Cost center': 'Pusat biaya',
  'Someone': 'Seseorang',
  'by {name}': 'oleh {name}',
  'Disc %': 'Disk %',
  'Tax %': 'Pajak %',
  'Net amount': 'Jumlah bersih',
  'Freight': 'Ongkos kirim',
  'Other charges': 'Biaya lainnya',
  'Order total': 'Total pesanan',
  'Send to supplier': 'Kirim ke pemasok',
  'Re-send': 'Kirim ulang',

  // --- Purchase orders: delivery tracking -----------------------------------
  'Delivery': 'Pengiriman',
  'Awaiting confirmation': 'Menunggu konfirmasi',
  'Confirmed': 'Dikonfirmasi',
  'Shipped': 'Dikirim',
  'In transit': 'Dalam perjalanan',
  'Delayed': 'Tertunda',
  'Delivered': 'Terkirim',
  'Update delivery': 'Perbarui pengiriman',
  'Update delivery status': 'Perbarui status pengiriman',
  'Track where the shipment stands. Every update is recorded in the activity log.':
    'Lacak posisi kiriman. Setiap pembaruan tercatat di log aktivitas.',
  'Delivery status': 'Status pengiriman',
  'Expected delivery date': 'Perkiraan tanggal tiba',
  'Carrier (optional)': 'Kurir (opsional)',
  'e.g. JNE, DHL, supplier truck': 'mis. JNE, DHL, truk pemasok',
  'Tracking reference (optional)': 'Nomor resi (opsional)',
  'Tracking or consignment number': 'Nomor resi atau nomor pengiriman',
  'e.g. customs cleared, arriving Friday morning': 'mis. sudah lolos bea cukai, tiba Jumat pagi',
  'Update status': 'Perbarui status',
  'Delivery status updated': 'Status pengiriman diperbarui',
  'Choose a delivery status.': 'Pilih status pengiriman.',
  'updated by {name}': 'diperbarui oleh {name}',

  // --- Purchase orders: optional supplier email / draft review --------------
  'Email draft': 'Kirim draf via email',
  'Email to supplier': 'Email ke pemasok',
  'Email draft for review': 'Kirim draf untuk ditinjau',
  'The draft is emailed clearly marked as “not a confirmed order”, so the supplier can review pricing and availability. The order stays a draft.':
    'Draf dikirim via email dengan tanda jelas “bukan pesanan terkonfirmasi”, agar pemasok dapat meninjau harga dan ketersediaan. Pesanan tetap berstatus draf.',
  'Approved and final. Record deliveries with “Receive goods” — emailing the order to the supplier is optional.':
    'Disetujui dan final. Catat penerimaan dengan “Terima barang” — mengirim pesanan ke pemasok via email bersifat opsional.',
  'Receive goods': 'Terima barang',
  'Return goods': 'Retur barang',
  'Short-close': 'Tutup lebih awal',
  'Delete purchase order': 'Hapus pesanan pembelian',
  'Step {order} of {total}: awaiting {role} approval.': 'Langkah {order} dari {total}: menunggu persetujuan {role}.',
  'approver': 'penyetuju',
  'You can approve or reject this step.': 'Anda dapat menyetujui atau menolak langkah ini.',
  'You do not hold the role required for this step.': 'Anda tidak memiliki peran yang diperlukan untuk langkah ini.',
  'No supplier is assigned yet. Edit the order to choose a supplier before submitting.':
    'Belum ada pemasok yang ditetapkan. Ubah pesanan untuk memilih pemasok sebelum mengajukan.',
  'Rejected:': 'Ditolak:',
  'Emailed to {recipient} on {date}.': 'Dikirim melalui email ke {recipient} pada {date}.',
  'Emailed to {recipient}.': 'Dikirim melalui email ke {recipient}.',
  'the supplier': 'pemasok',
  'Partially received. Record further deliveries with “Receive goods” to close the order.':
    'Diterima sebagian. Catat kiriman berikutnya dengan “Terima barang” untuk menutup pesanan.',
  'Fully received and closed.': 'Diterima sepenuhnya dan ditutup.',
  'Goods receipts': 'Penerimaan barang',
  '1 delivery recorded': '1 kiriman tercatat',
  '{count} deliveries recorded': '{count} kiriman tercatat',
  'against this order — what was accepted, rejected, when and by whom.':
    'untuk pesanan ini — apa yang diterima, ditolak, kapan, dan oleh siapa.',
  'Received {date}': 'Diterima {date}',
  'recorded {timestamp}': 'dicatat {timestamp}',
  'unknown': 'tidak diketahui',
  'No line detail.': 'Tidak ada detail baris.',
  'Accepted': 'Diterima',
  'Note:': 'Catatan:',
  'Over-receipt': 'Penerimaan berlebih',
  'Discrepancy open': 'Selisih terbuka',
  'Discrepancy resolved': 'Selisih terselesaikan',
  'Approval chain': 'Rantai persetujuan',
  'Authorisation': 'Otorisasi',
  'Buyer signature': 'Tanda tangan pembeli',
  'Approver signature': 'Tanda tangan penyetuju',
  '— not signed —': '— belum ditandatangani —',
  'Rejected by': 'Ditolak oleh',
  'Approved by': 'Disetujui oleh',
  'Add a comment for the team…': 'Tambahkan komentar untuk tim…',
  'Comment': 'Komentar',
  'No activity yet': 'Belum ada aktivitas',
  'Lifecycle events and comments will appear here.': 'Peristiwa siklus dokumen dan komentar akan muncul di sini.',
  'Approve purchase order': 'Setujui pesanan pembelian',
  'Reject purchase order': 'Tolak pesanan pembelian',
  'Optionally add a note for the buyer.': 'Tambahkan catatan untuk pembeli (opsional).',
  'Tell the buyer why this is being rejected.': 'Beri tahu pembeli alasan penolakan ini.',
  'Comment (optional)': 'Komentar (opsional)',
  'Reason': 'Alasan',
  'Send order to supplier': 'Kirim pesanan ke pemasok',
  'The full purchase order is emailed to the recipient below.':
    'Pesanan pembelian lengkap dikirim melalui email ke penerima di bawah.',
  'Recipient': 'Penerima',
  'Looking up supplier contact…': 'Mencari kontak pemasok…',
  'CC (optional)': 'CC (opsional)',
  'Comma-separated email addresses': 'Alamat email dipisahkan koma',
  'Separate multiple addresses with commas.': 'Pisahkan beberapa alamat dengan koma.',
  'Message (optional)': 'Pesan (opsional)',
  'Add a note to the supplier (appears at the top of the email).':
    'Tambahkan catatan untuk pemasok (muncul di bagian atas email).',
  'Send order': 'Kirim pesanan',
  'Cancel purchase order': 'Batalkan pesanan pembelian',
  "Cancelling stops this order from being approved or issued. This can't be undone.":
    'Pembatalan menghentikan pesanan ini agar tidak disetujui atau diterbitkan. Tindakan ini tidak dapat dibatalkan.',
  'Cancel order': 'Batalkan pesanan',
  'Short-close purchase order': 'Tutup lebih awal pesanan pembelian',
  "Close this order without receiving the outstanding quantity. Already-received items are kept; no further deliveries can be recorded. Use this when the supplier won't fulfil the remainder.":
    'Tutup pesanan ini tanpa menerima sisa kuantitas. Barang yang sudah diterima tetap tercatat; kiriman selanjutnya tidak dapat dicatat lagi. Gunakan ini saat pemasok tidak akan memenuhi sisanya.',
  'Short-close order': 'Tutup pesanan lebih awal',
  'Reason (optional) — e.g. supplier discontinued the item': 'Alasan (opsional) — mis. pemasok menghentikan barang tersebut',
  "Permanently delete {number}? This can't be undone.": 'Hapus {number} secara permanen? Tindakan ini tidak dapat dibatalkan.',

  // --- Purchase orders: form -----------------------------------------------
  'Only draft purchase orders can be edited.': 'Hanya pesanan pembelian berstatus draf yang dapat diubah.',
  'Approved orders are final and can no longer be edited.':
    'Pesanan yang sudah disetujui bersifat final dan tidak dapat diubah lagi.',
  'This order is awaiting approval. Saving your changes will withdraw it from approval — the approval chain resets and it must be resubmitted.':
    'Pesanan ini sedang menunggu persetujuan. Menyimpan perubahan akan menariknya dari alur persetujuan — rantai persetujuan direset dan pesanan harus diajukan ulang.',
  'Could not load purchase order': 'Tidak dapat memuat pesanan pembelian',
  '— No location —': '— Tanpa lokasi —',
  '— Select supplier —': '— Pilih pemasok —',
  '— None —': '— Tidak ada —',
  'Enter a title.': 'Masukkan judul.',
  'Every line needs a description.': 'Setiap baris memerlukan deskripsi.',
  '"{line}" needs a quantity greater than 0.': '"{line}" memerlukan kuantitas lebih dari 0.',
  'A line': 'Sebuah baris',
  'Assign a supplier before submitting.': 'Tetapkan pemasok sebelum mengajukan.',
  '{number} submitted for approval': '{number} diajukan untuk persetujuan',
  'Submitted over budget': 'Diajukan melebihi anggaran',
  'Purchase order updated': 'Pesanan pembelian diperbarui',
  '{number} created': '{number} dibuat',
  'Could not save purchase order': 'Tidak dapat menyimpan pesanan pembelian',
  'Edit purchase order': 'Ubah pesanan pembelian',
  'New purchase order': 'Pesanan pembelian baru',
  'Commit an order to a supplier. Submit it to route for approval.':
    'Buat komitmen pesanan kepada pemasok. Ajukan untuk dialurkan ke persetujuan.',
  'e.g. Weekly produce order': 'mis. Pesanan sayur mingguan',
  'Deliver-to location': 'Lokasi tujuan kirim',
  'Expected date': 'Tanggal perkiraan tiba',
  'Delivery instructions or context (optional)': 'Instruksi pengiriman atau konteks (opsional)',
  'Line items': 'Baris barang',
  'Search catalog…': 'Cari katalog…',
  'Search items…': 'Cari barang…',
  'Search name or SKU…': 'Cari nama atau SKU…',
  'Searching…': 'Mencari…',
  'No catalog matches': 'Tidak ada katalog yang cocok',
  'Catalog item': 'Barang katalog',
  'Remove line': 'Hapus baris',
  'Coding': 'Pengodean',
  'Line cost centre': 'Pusat biaya baris',
  'Line GL account': 'Akun GL baris',
  'Add blank line': 'Tambah baris kosong',
  'Freight amount': 'Jumlah ongkos kirim',
  'Save draft': 'Simpan draf',
  'Save & submit': 'Simpan & ajukan',

  // --- Purchase orders: print ----------------------------------------------
  'Could not load purchase order.': 'Tidak dapat memuat pesanan pembelian.',
  'Print / Save as PDF': 'Cetak / Simpan sebagai PDF',
  'Purchase Order': 'Pesanan Pembelian',
  'Step {order}': 'Langkah {order}',
  'Audit trail': 'Jejak audit',
  'Generated {timestamp}': 'Dibuat {timestamp}',

  // --- Receiving: list -------------------------------------------------------
  'Goods receipts against issued purchase orders. Posting a receipt updates stock on hand and purchase history.':
    'Penerimaan barang atas pesanan pembelian yang diterbitkan. Memposting penerimaan memperbarui stok tersedia dan riwayat pembelian.',
  'Record receipt': 'Catat penerimaan',
  'Search by GRN, PO or supplier…': 'Cari berdasarkan GRN, PO, atau pemasok…',
  'Failed to load goods receipts.': 'Gagal memuat penerimaan barang.',
  "Couldn't load goods receipts": 'Tidak dapat memuat penerimaan barang',
  'No matching goods receipts': 'Tidak ada penerimaan barang yang cocok',
  'No goods receipts yet': 'Belum ada penerimaan barang',
  'Open a sent purchase order and choose “Receive goods” to record a delivery.':
    'Buka pesanan pembelian yang terkirim dan pilih “Terima barang” untuk mencatat kiriman.',
  'GRN': 'GRN',
  'Purchase order': 'Pesanan pembelian',
  'No supplier': 'Tanpa pemasok',
  'Over': 'Berlebih',
  'Discrepancy': 'Selisih',
  'Resolved': 'Terselesaikan',
  'Value': 'Nilai',
  'Received by': 'Diterima oleh',
  'Posted': 'Diposting',
  'Record a receipt': 'Catat penerimaan',
  "Pick the purchase order you're receiving against. Only approved orders awaiting delivery are shown.":
    'Pilih pesanan pembelian yang menjadi dasar penerimaan. Hanya pesanan yang disetujui dan menunggu kiriman yang ditampilkan.',
  'Search by PO number or supplier…': 'Cari berdasarkan nomor PO atau pemasok…',
  'No orders awaiting delivery': 'Tidak ada pesanan yang menunggu kiriman',
  'No approved orders match your search.': 'Tidak ada pesanan disetujui yang cocok dengan pencarian Anda.',
  'Approve a purchase order first, then receive against it here.':
    'Setujui pesanan pembelian terlebih dahulu, lalu catat penerimaannya di sini.',

  // --- PO picker cards (record receipt / start return drawers) ----------------
  'From {number}': 'Dari {number}',
  '{received}/{total} lines received': '{received}/{total} baris diterima',
  '{n} line(s)': '{n} baris',

  // --- Receiving: receive-goods form -----------------------------------------
  'This goods receipt has been posted and can no longer be edited.':
    'Penerimaan barang ini sudah diposting dan tidak dapat diubah lagi.',
  'Goods receipt not found.': 'Penerimaan barang tidak ditemukan.',
  'Enter an accepted or rejected quantity on at least one line.':
    'Masukkan kuantitas diterima atau ditolak pada minimal satu baris.',
  'Draft saved': 'Draf tersimpan',
  'Could not save draft': 'Tidak dapat menyimpan draf',
  'Goods receipt {number} posted': 'Penerimaan barang {number} diposting',
  'Could not post receipt': 'Tidak dapat memposting penerimaan',
  "Can't edit this receipt": 'Penerimaan ini tidak dapat diubah',
  'View receipt': 'Lihat penerimaan',
  'Back to receiving': 'Kembali ke penerimaan',
  'Total quantity on this purchase order line': 'Total kuantitas pada baris pesanan pembelian ini',
  'Ordered': 'Dipesan',
  'Quantity accepted into stock on earlier deliveries': 'Kuantitas yang diterima ke stok pada kiriman sebelumnya',
  'Accepted earlier': 'Diterima sebelumnya',
  "Quantity rejected on earlier deliveries — still owed by the supplier, so it stays in 'Still due' until re-delivered":
    "Kuantitas yang ditolak pada kiriman sebelumnya — masih menjadi kewajiban pemasok, sehingga tetap dihitung dalam 'Masih terutang' sampai dikirim ulang",
  'Rejected earlier': 'Ditolak sebelumnya',
  'Quantity still owed by the supplier (ordered − accepted). Includes anything previously rejected, since that must be re-delivered.':
    'Kuantitas yang masih menjadi kewajiban pemasok (dipesan − diterima). Termasuk yang sebelumnya ditolak, karena harus dikirim ulang.',
  'Still due': 'Masih terutang',
  'Accept': 'Terima',
  'Reason for rejection': 'Alasan penolakan',
  'Discrepancy reason': 'Alasan selisih',
  'Select a reason…': 'Pilih alasan…',
  'Note (optional)': 'Catatan (opsional)',
  'e.g. 2 cartons crushed in transit': 'mis. 2 kardus rusak saat pengiriman',
  'Back to draft': 'Kembali ke draf',
  'Edit draft': 'Ubah draf',
  'Goods can only be received against an approved order. This order is {status}.':
    'Barang hanya dapat diterima atas pesanan yang telah disetujui. Pesanan ini berstatus {status}.',
  'One or more lines receive more than the outstanding quantity. This is allowed but will be flagged as an over-receipt.':
    'Satu baris atau lebih menerima melebihi sisa kuantitas. Ini diizinkan tetapi akan ditandai sebagai penerimaan berlebih.',
  'This delivery has discrepancies. Rejected goods stay outstanding on the order, and the buyer and requester will be notified to follow up with the supplier.':
    'Kiriman ini memiliki selisih. Barang yang ditolak tetap terutang pada pesanan, dan pembeli serta peminta akan diberi tahu untuk menindaklanjuti dengan pemasok.',
  'Received date': 'Tanggal diterima',
  'Receive into location': 'Terima ke lokasi',
  '— Select location —': '— Pilih lokasi —',
  'Delivery / packing note': 'Surat jalan / catatan pengepakan',
  'Supplier delivery note #': 'No. surat jalan pemasok',
  'Enter how much you': 'Masukkan berapa banyak yang Anda',
  'accept': 'terima',
  'into stock. If a delivery is short, damaged or wrong, enter the':
    'ke stok. Jika kiriman kurang, rusak, atau salah, masukkan kuantitas',
  'reject': 'tolak',
  'quantity and a reason — rejected goods stay outstanding on the order.':
    'beserta alasannya — barang yang ditolak tetap terutang pada pesanan.',
  'Receive all outstanding': 'Terima semua sisa',
  'Condition, discrepancies, who delivered…': 'Kondisi, selisih, siapa yang mengantar…',
  'Receiving value:': 'Nilai penerimaan:',
  'Post receipt': 'Posting penerimaan',

  // --- Receiving: per-line delivery photos ------------------------------------
  'Photos': 'Foto',
  'required to post': 'wajib untuk posting',
  'Add photo': 'Tambah foto',
  'Remove photo': 'Hapus foto',
  'Could not remove photo': 'Tidak dapat menghapus foto',
  'Take or upload a photo of the delivered goods for this line.':
    'Ambil atau unggah foto barang yang dikirim untuk baris ini.',
  'Photo evidence is required: add a photo to every line with an accepted or rejected quantity before posting. {count} line(s) still need a photo.':
    'Bukti foto wajib: tambahkan foto pada setiap baris dengan kuantitas diterima atau ditolak sebelum posting. {count} baris masih memerlukan foto.',
  'Add a photo to every received line before posting.':
    'Tambahkan foto pada setiap baris yang diterima sebelum posting.',
  'Draft saved, but some photos failed to upload':
    'Draf tersimpan, tetapi sebagian foto gagal diunggah',

  // --- Receiving: goods receipt detail ----------------------------------------
  "Couldn't load goods receipt": 'Tidak dapat memuat penerimaan barang',
  'Discrepancy marked as resolved': 'Selisih ditandai terselesaikan',
  'Could not resolve discrepancy': 'Tidak dapat menyelesaikan selisih',
  'Draft discarded': 'Draf dibuang',
  'Could not discard draft': 'Tidak dapat membuang draf',
  'Receipt cancelled and reversed': 'Penerimaan dibatalkan dan dibalikkan',
  'Could not cancel receipt': 'Tidak dapat membatalkan penerimaan',
  'Discard': 'Buang',
  'Cancel receipt': 'Batalkan penerimaan',
  'Received into': 'Diterima ke',
  'Delivery note': 'Surat jalan',
  'Recorded': 'Dicatat',
  'Over-received': 'Diterima berlebih',
  '{accepted} accepted · {rejected} rejected · {value}': '{accepted} diterima · {rejected} ditolak · {value}',
  'Draft goods receipt': 'Draf penerimaan barang',
  'Goods receipt {number}': 'Penerimaan barang {number}',
  'This receipt is a draft — nothing has been committed to stock, the purchase order or the budget yet. Edit it as needed, then post it to finalize.':
    'Penerimaan ini masih draf — belum ada yang dicatat ke stok, pesanan pembelian, atau anggaran. Ubah seperlunya, lalu posting untuk menyelesaikannya.',
  'This receipt was cancelled': 'Penerimaan ini dibatalkan',
  'on {date}': 'pada {date}',
  'Stock, the purchase order and purchase history were reversed.':
    'Stok, pesanan pembelian, dan riwayat pembelian telah dibalikkan.',
  'Reason: {reason}': 'Alasan: {reason}',
  'This receipt includes one or more over-received lines (more than the outstanding ordered quantity).':
    'Penerimaan ini mencakup satu baris atau lebih yang diterima berlebih (melebihi sisa kuantitas yang dipesan).',
  'This receipt has an open discrepancy awaiting supplier follow-up. Rejected goods were not added to stock and remain outstanding on the order.':
    'Penerimaan ini memiliki selisih terbuka yang menunggu tindak lanjut pemasok. Barang yang ditolak tidak ditambahkan ke stok dan tetap terutang pada pesanan.',
  'Received value': 'Nilai diterima',
  'Resolved by': 'Diselesaikan oleh',
  'Resolved at': 'Diselesaikan pada',
  'Resolution': 'Penyelesaian',
  'Record how this was resolved with the supplier (credit note, replacement delivery, or accepted as-is), then mark it resolved.':
    'Catat bagaimana hal ini diselesaikan dengan pemasok (nota kredit, kiriman pengganti, atau diterima apa adanya), lalu tandai terselesaikan.',
  'Resolution notes (e.g. credit note CN-123 received, replacement due Friday)…':
    'Catatan penyelesaian (mis. nota kredit CN-123 diterima, pengganti tiba Jumat)…',
  'Mark resolved': 'Tandai terselesaikan',
  'Received lines': 'Baris diterima',
  'Accepted quantities will be added to stock when this receipt is posted. Rejected quantities are recorded but never stocked.':
    'Kuantitas yang diterima akan ditambahkan ke stok saat penerimaan ini diposting. Kuantitas yang ditolak dicatat tetapi tidak pernah masuk stok.',
  'Accepted quantities were added to stock. Rejected quantities were not stocked and stay outstanding on the order.':
    'Kuantitas yang diterima telah ditambahkan ke stok. Kuantitas yang ditolak tidak masuk stok dan tetap terutang pada pesanan.',
  'Audit trail for this receipt — who did what and when.': 'Jejak audit penerimaan ini — siapa melakukan apa dan kapan.',
  'Posting and discrepancy events will appear here.': 'Peristiwa posting dan selisih akan muncul di sini.',
  'Post goods receipt': 'Posting penerimaan barang',
  'Posting commits the accepted quantities to stock, advances the purchase order and writes purchase history. You can still cancel it afterwards if needed.':
    'Posting mencatat kuantitas yang diterima ke stok, memajukan pesanan pembelian, dan menulis riwayat pembelian. Anda masih dapat membatalkannya kemudian jika diperlukan.',
  'Discard draft receipt': 'Buang draf penerimaan',
  "Permanently delete this draft. Nothing has been committed to stock, so there's nothing to reverse. This can't be undone.":
    'Hapus draf ini secara permanen. Belum ada yang dicatat ke stok, jadi tidak ada yang perlu dibalikkan. Tindakan ini tidak dapat dibatalkan.',
  'Discard draft': 'Buang draf',
  'Cancel goods receipt': 'Batalkan penerimaan barang',
  "This reverses the accepted stock, restores the purchase order's outstanding quantities and deletes the purchase-history records. If any of this stock has already been issued, the cancel will be blocked.":
    'Ini membalikkan stok yang diterima, memulihkan sisa kuantitas pesanan pembelian, dan menghapus catatan riwayat pembelian. Jika sebagian stok ini sudah dikeluarkan, pembatalan akan diblokir.',
  'Reason (optional) — e.g. posted against the wrong PO': 'Alasan (opsional) — mis. diposting ke PO yang salah',

  // --- Discrepancy / return reasons ------------------------------------------
  'Damaged': 'Rusak',
  'Wrong item': 'Barang salah',
  'Short delivery': 'Kiriman kurang',
  'Over delivery': 'Kiriman berlebih',
  'Quality issue': 'Masalah kualitas',
  'Expired / short shelf life': 'Kedaluwarsa / masa simpan pendek',
  'Overstock': 'Stok berlebih',
  'Other': 'Lainnya',

  // --- Returns: list -----------------------------------------------------------
  'Goods returned to suppliers (RMAs). Posting a return reverses stock, restores the purchase order and records a negative purchase entry; track the credit note alongside.':
    'Barang yang diretur ke pemasok (RMA). Memposting retur membalikkan stok, memulihkan pesanan pembelian, dan mencatat entri pembelian negatif; lacak nota kredit bersamaan.',
  'New return': 'Retur baru',
  'Search by return, PO, supplier or credit note…': 'Cari berdasarkan retur, PO, pemasok, atau nota kredit…',
  'Failed to load returns.': 'Gagal memuat retur.',
  "Couldn't load returns": 'Tidak dapat memuat retur',
  'No matching returns': 'Tidak ada retur yang cocok',
  'No returns yet': 'Belum ada retur',
  'Open a received purchase order and choose “Return goods”, or start one here.':
    'Buka pesanan pembelian yang telah diterima dan pilih “Retur barang”, atau mulai di sini.',
  'Return': 'Retur',
  'Return date': 'Tanggal retur',
  'Returned': 'Diretur',
  'Credit note': 'Nota kredit',
  'No credit': 'Tanpa kredit',
  'Credit expected': 'Kredit diharapkan',
  'Credit received': 'Kredit diterima',
  'Start a return': 'Mulai retur',
  "Pick the purchase order you're returning against. Only orders that have received goods are shown.":
    'Pilih pesanan pembelian yang menjadi dasar retur. Hanya pesanan yang telah menerima barang yang ditampilkan.',
  'No orders with received goods': 'Tidak ada pesanan dengan barang diterima',
  'No matching orders have received deliveries.': 'Tidak ada pesanan cocok yang telah menerima kiriman.',
  'Receive goods against a purchase order first, then you can return them here.':
    'Terima barang atas pesanan pembelian terlebih dahulu, lalu Anda dapat meretur di sini.',

  // --- Returns: form -------------------------------------------------------------
  'Enter a return quantity on at least one line.': 'Masukkan kuantitas retur pada minimal satu baris.',
  'Draft return saved': 'Draf retur tersimpan',
  'Return {number} posted': 'Retur {number} diposting',
  'Could not post return': 'Tidak dapat memposting retur',
  'Back to returns': 'Kembali ke retur',
  'Total ordered on this line': 'Total dipesan pada baris ini',
  'Quantity accepted into stock — the most you can return':
    'Kuantitas yang diterima ke stok — jumlah maksimum yang dapat diretur',
  'Return qty': 'Kts retur',
  'More than received': 'Melebihi yang diterima',
  'Return reason': 'Alasan retur',
  'e.g. 3 units spoiled on arrival': 'mis. 3 unit rusak saat tiba',
  'from {number}': 'dari {number}',
  'Goods can only be returned against an order that has received deliveries. This order is {status}.':
    'Barang hanya dapat diretur atas pesanan yang telah menerima kiriman. Pesanan ini berstatus {status}.',
  "No lines on this order have received stock yet, so there's nothing to return.":
    'Belum ada baris pada pesanan ini yang menerima stok, jadi tidak ada yang dapat diretur.',
  'One or more lines return more than was received. Reduce the quantity to the received amount or less.':
    'Satu baris atau lebih meretur melebihi yang diterima. Kurangi kuantitas hingga sebesar jumlah yang diterima atau kurang.',
  'Return stock from': 'Retur stok dari',
  'Return from location': 'Retur dari lokasi',
  "Enter the quantity to return per line. Posting reverses that stock and decrements the order's received quantity. You can't return more than was received.":
    'Masukkan kuantitas retur per baris. Posting membalikkan stok tersebut dan mengurangi kuantitas diterima pada pesanan. Anda tidak dapat meretur melebihi yang diterima.',
  'Return all received': 'Retur semua yang diterima',
  'Nothing to return': 'Tidak ada yang dapat diretur',
  'No lines on this order have received stock.': 'Tidak ada baris pada pesanan ini yang menerima stok.',
  'Why are these goods being returned? Reference any supplier RMA or collection details…':
    'Mengapa barang ini diretur? Rujuk RMA pemasok atau detail penjemputan…',
  'Return value:': 'Nilai retur:',
  'Post return': 'Posting retur',

  // --- Returns: detail --------------------------------------------------------------
  'Return not found.': 'Retur tidak ditemukan.',
  "Couldn't load return": 'Tidak dapat memuat retur',
  'Return cancelled and reversed': 'Retur dibatalkan dan dibalikkan',
  'Draft return cancelled': 'Draf retur dibatalkan',
  'Could not cancel return': 'Tidak dapat membatalkan retur',
  'Credit note updated': 'Nota kredit diperbarui',
  'Could not record credit note': 'Tidak dapat mencatat nota kredit',
  'Cancel & reverse': 'Batalkan & balikkan',
  'Goods receipt': 'Penerimaan barang',
  'Returned from': 'Diretur dari',
  'Posted by': 'Diposting oleh',
  'Ref {reference}': 'Ref {reference}',
  'Return {number}': 'Retur {number}',
  'Draft return': 'Draf retur',
  'This return is a draft — no stock, purchase-order or history changes have been made. Post it to reverse the stock and update the order.':
    'Retur ini masih draf — belum ada perubahan stok, pesanan pembelian, atau riwayat. Posting untuk membalikkan stok dan memperbarui pesanan.',
  'This return was cancelled': 'Retur ini dibatalkan',
  'Any stock and purchase-order effects were reversed.': 'Semua efek pada stok dan pesanan pembelian telah dibalikkan.',
  'Return value': 'Nilai retur',
  "Track the supplier's credit note for this return. Default amount is the return value; adjust it to match what the supplier actually credits.":
    'Lacak nota kredit pemasok untuk retur ini. Jumlah bawaan adalah nilai retur; sesuaikan agar cocok dengan kredit yang benar-benar diberikan pemasok.',
  'Credit note reference': 'Referensi nota kredit',
  'e.g. CN-10293': 'mis. CN-10293',
  'Amount ({currency})': 'Jumlah ({currency})',
  'Credit note status': 'Status nota kredit',
  'Save credit note': 'Simpan nota kredit',
  'Returned lines': 'Baris diretur',
  'These quantities were reversed out of stock and deducted from the purchase order.':
    'Kuantitas ini telah dibalikkan keluar dari stok dan dikurangkan dari pesanan pembelian.',
  'These quantities will be reversed out of stock when the return is posted.':
    'Kuantitas ini akan dibalikkan keluar dari stok saat retur diposting.',
  'Audit trail for this return — who did what and when.': 'Jejak audit retur ini — siapa melakukan apa dan kapan.',
  'Posting, cancellation and credit-note events will appear here.':
    'Peristiwa posting, pembatalan, dan nota kredit akan muncul di sini.',
  "Posting reverses the returned quantities out of stock, decrements the purchase order's received quantities and writes a negative purchase-history entry. You can still cancel it afterwards.":
    'Posting membalikkan kuantitas retur keluar dari stok, mengurangi kuantitas diterima pada pesanan pembelian, dan menulis entri riwayat pembelian negatif. Anda masih dapat membatalkannya kemudian.',
  'Cancel & reverse return': 'Batalkan & balikkan retur',
  'Discard draft return': 'Buang draf retur',
  "This restores the returned stock and the purchase order's received quantities, and deletes the negative purchase-history records.":
    'Ini memulihkan stok yang diretur dan kuantitas diterima pada pesanan pembelian, serta menghapus catatan riwayat pembelian negatif.',
  'This voids the draft return. Nothing has been committed, so there is nothing to reverse.':
    'Ini membatalkan draf retur. Belum ada yang dicatat, jadi tidak ada yang perlu dibalikkan.',
  'Cancel return': 'Batalkan retur',
  'Reason (optional)': 'Alasan (opsional)',
};

export default dict;
